<template>
    <v-row justify="center">
        <v-dialog v-model="internalDialog" persistent max-width="800">
            <v-card>
                <v-toolbar color="primary">
                    <v-icon dark>mdi-pencil</v-icon>
                    <div style="color: white; margin-left: 10px;" class="text-h6">{{ title }}</div>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="formEditPublicacao" v-model="internalFormValid">
                        <v-row>
                            <v-col cols="12" sm="12" md="6">
                                <v-select 
                                    :value="telaSelected" 
                                    @input="$emit('update:telaSelected', $event)"
                                    :items="banners" 
                                    item-text="cod_recurso" 
                                    item-value="id_recurso" 
                                    :label="screenLabel"
                                    disabled
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-select 
                                    :value="aviso.id_banner" 
                                    @input="updateAvisoField('id_banner', $event)"
                                    :items="bannersFiltered" 
                                    item-text="descricao" 
                                    item-value="id_banner" 
                                    :label="bannerLabel"
                                    disabled
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="4">
                                <v-select 
                                    :value="aviso.id_categoria_aviso" 
                                    @input="updateAvisoField('id_categoria_aviso', $event)"
                                    :items="categoriasAvisos" 
                                    item-text="descricao_categoria" 
                                    item-value="id_categoria_aviso" 
                                    :label="categoryLabel"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-datetime-picker
                                    :label="validityStartLabel"
                                    ref="dtiInput"
                                    :value="dti"
                                    @input="$emit('update:dti', $event)"
                                    :time-picker-props="timeProps"
                                    :date-picker-props="dtiProps"
                                    :text-field-props="textFieldPropsInicio"
                                    time-format="HH:mm:ss"
                                    date-format="dd/MM/yyyy"
                                    :clear-text="clearText"
                                >
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-datetime-picker
                                    :label="validityEndLabel"
                                    ref="dtfInput"
                                    :value="dtf"
                                    @input="$emit('update:dtf', $event)"
                                    :time-picker-props="timeProps"
                                    :date-picker-props="dtfProps"
                                    :text-field-props="textFieldPropsFim"
                                    time-format="HH:mm:ss"
                                    date-format="dd/MM/yyyy"
                                    :clear-text="clearText"
                                >
                                    <template slot="dateIcon">
                                        <v-icon>mdi-calendar</v-icon>
                                    </template>
                                    <template slot="timeIcon">
                                        <v-icon>mdi-clock</v-icon>
                                    </template>
                                </v-datetime-picker>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="primary" @click="handleCancel">{{ cancelText }}</v-btn>
                    <v-btn dark color="primary" @click="handleSave">{{ saveText }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'EditPublicacaoDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        telaSelected: {
            type: [Number, String],
            default: null
        },
        banners: {
            type: Array,
            default: () => []
        },
        bannersFiltered: {
            type: Array,
            default: () => []
        },
        aviso: {
            type: Object,
            default: () => ({})
        },
        categoriasAvisos: {
            type: Array,
            default: () => []
        },
        dti: {
            type: [Date, String],
            default: null
        },
        dtf: {
            type: [Date, String],
            default: null
        },
        dtiProps: {
            type: Object,
            default: () => ({})
        },
        dtfProps: {
            type: Object,
            default: () => ({})
        },
        timeProps: {
            type: Object,
            default: () => ({ useSeconds: true })
        },
        textFieldPropsInicio: {
            type: Object,
            default: () => ({ prependInnerIcon: 'mdi-calendar' })
        },
        textFieldPropsFim: {
            type: Object,
            default: () => ({ prependInnerIcon: 'mdi-calendar' })
        },
        screenLabel: {
            type: String,
            default: 'Tela'
        },
        bannerLabel: {
            type: String,
            default: 'Banner'
        },
        categoryLabel: {
            type: String,
            default: 'Categoria'
        },
        validityStartLabel: {
            type: String,
            default: 'Início da Vigência'
        },
        validityEndLabel: {
            type: String,
            default: 'Fim da Vigência'
        },
        clearText: {
            type: String,
            default: 'Fechar'
        },
        cancelText: {
            type: String,
            default: 'Cancelar'
        },
        saveText: {
            type: String,
            default: 'Salvar'
        },
        formValid: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        internalDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        internalFormValid: {
            get() {
                return this.formValid;
            },
            set(value) {
                this.$emit('update:formValid', value);
            }
        }
    },
    methods: {
        updateAvisoField(field, value) {
            const updatedAviso = { ...this.aviso, [field]: value };
            this.$emit('update:aviso', updatedAviso);
        },
        handleCancel() {
            this.$emit('cancel');
        },
        handleSave() {
            this.$emit('save');
        },
        validate() {
            return this.$refs.formEditPublicacao.validate();
        },
        resetValidation() {
            if (this.$refs.formEditPublicacao) {
                this.$refs.formEditPublicacao.resetValidation();
            }
        },
        clearDtiInput() {
            if (this.$refs.dtiInput) {
                this.$refs.dtiInput.clearHandler();
            }
        },
        clearDtfInput() {
            if (this.$refs.dtfInput) {
                this.$refs.dtfInput.clearHandler();
            }
        }
    }
}
</script>

